import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useCancellationPlan } from 'src/context/billing';

const KeepPlanDialog = () => {
  const {
    ui: { step, setInitialData },
  } = useCancellationPlan();

  const onOpenChange = (open: boolean) => {
    if (!open) {
      setInitialData();
    }
  };

  return (
    <Dialog open={step === 'keep-plan'} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[512px] gap-6">
        <DialogHeader className="text-center gap-1.5">
          <DialogTitle>You’re all set!</DialogTitle>
          <DialogDescription>
            Your current plan will continue as is, so you can keep enjoying all the features and benefits without
            interruption.
            <br />
            <br />
            No action is needed—just sit back and stay on track with your plan.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center">
          <DialogClose asChild>
            <Button>Back to dashboard</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default KeepPlanDialog;
